import React from 'react';

// se questo import non utilizzato viene rimosso si rompe tutto
import new_axios_instance from '../../../axios_instance';

import { Link } from 'react-router-dom';
import { useSelector } from "react-redux";

import logoRec from '../../../assets/img/logoREC.png';

import cx from 'classnames';
import bootstrapCSS from '../../../assets/global-style/bootstrap.module.css'
import animateCSS from '../../../assets/global-style/animate.module.css'
import headerModuleStyle from './css/Header.module.css';

import { Notifs, Breadcrumbs } from "../../index";
import { DataUser, Images, NavBarMenuItems } from "./index";
import { capitalizeFirstLetter, isPwa } from '../../../fanctionUtility';
import { useLocation } from 'react-router-dom';


const Header = () => {
    const navbarSupportedContentCollapsible = React.useRef();
    const headerRef = React.useRef();

    const auth = useSelector(state => state.auth);
    const configurationFile = useSelector(state => state.configurationFile);
    const pathBreadcrumb = useSelector(state => state.breadcrumb.path);
    const location = useLocation()

    // La riga "header" della griglia in #root (public/index.html) ha un'altezza di default
    // fissa (13.8rem), pensata per l'header completo coi loghi. Pagine come l'Editor Database
    // nascondono quella sezione per guadagnare spazio: senza questa misura reale, la griglia
    // continuerebbe a riservare lo spazio del vecchio header, lasciando un vuoto sopra il contenuto.
    React.useEffect(() => {
        const headerEl = headerRef.current;
        if (!headerEl || isPwa()) return;

        const aggiornaAltezza = () => {
            document.documentElement.style.setProperty('--header-height', `${headerEl.offsetHeight}px`);
        };

        aggiornaAltezza();
        // Applicare la modifica al DOM in requestAnimationFrame (invece che sincrona dentro il
        // callback) evita il warning "ResizeObserver loop completed with undelivered
        // notifications": la mutazione stessa farebbe scattare un altro giro di osservazione
        // nello stesso ciclo, cosa che Chrome segnala come errore (benigno, ma bloccante in dev).
        const observer = new ResizeObserver(() => requestAnimationFrame(aggiornaAltezza));
        observer.observe(headerEl);

        return () => {
            observer.disconnect();
            document.documentElement.style.removeProperty('--header-height');
        };
    }, [location.pathname, auth.ruoloScelto, auth.token]);

    const logoutARPA = React.useCallback((e) => {
        e.preventDefault();
        e.stopPropagation();
        let logoutUrl = `${configurationFile.fileConf.baseUrlAuthService}/logout`;
        let redirectUrl = configurationFile.fileConf.redirectUri;
        logoutUrl += `?post_logout_redirect_uri=${encodeURIComponent(redirectUrl)}&client_id=${configurationFile.fileConf.clientId}`;
        window.location.href = logoutUrl
        sessionStorage.clear()
    }, [configurationFile]);

    const openMenuCollapse = () => {
        navbarSupportedContentCollapsible.current.classList.toggle('show');
    };

    const getComponentName = () => {
        const path = location.pathname
        let name = path.split('/').pop()
        if (name === 'schedaCorso') {
            name = 'Utenti'
        } else if (name === '') {
            name = 'Home'
        }

        return capitalizeFirstLetter(name)
    }

    const goBack = () => {
        window.history.back()
    }

    return isPwa() ? (
        <>
            {getComponentName() !== 'Login' && <div className="border-bottom" style={{ backgroundColor: '#e9ecef' }}>
                <div className="d-flex align-items-center p-2">
                    <button onClick={goBack} className="btn">
                        <i className="fa fa-chevron-left" style={{ fontSize: '20px' }} />
                    </button>
                    <div className="flex-grow-1 text-center">
                        <h2 className="m-0 mr-4">{getComponentName()}</h2>
                    </div>
                </div>
            </div>}
        </>
    ) : (
        <header ref={headerRef} className='animate__animated animate__fadeIn fixed-top' style={{ gridArea: "header" }}>
            <div className='shadow'>
                <nav className={`navbar-light navbar-expand-lg ${cx(bootstrapCSS.navbar, animateCSS.animated, animateCSS.fadeIn)}`}
                    style={{ borderBottom: '6px solid #e5000a', backgroundColor: 'white' }}>

                    <Link to='/' className="navbar-brand bg-white p-2"
                        style={{ cursor: 'pointer' }}>
                        <img src={logoRec} alt="Registro Elettronico" className='img-fluid' />
                    </Link>

                    {(auth.token && auth.token !== '') ? (
                        <>
                            <button className="navbar-toggler" type="button"
                                onClick={() => openMenuCollapse()}
                                id='buttonCollapse'
                                style={{ outline: 'none' }}>
                                <span className="navbar-toggler-icon">&nbsp;</span>
                            </button>

                            <div className="collapse navbar-collapse px-3"
                                ref={navbarSupportedContentCollapsible}
                                id="navbarSupportedContentCollapsible">

                                <NavBarMenuItems ruoloScelto={auth.ruoloScelto} userCf={auth.user && auth.user.USER_CF} />

                                <div className={cx(
                                    bootstrapCSS['navbar-nav'],
                                    headerModuleStyle['navbar-nav__extends'])}>

                                    <div className={cx(
                                        bootstrapCSS['nav-item'],
                                        bootstrapCSS.dropdown,
                                        headerModuleStyle['nav-item'])}>

                                        <DataUser cleanSessionStorage={logoutARPA}
                                        />
                                    </div>

                                    <div className="nav-item">
                                        <Link to='/login'
                                            id='buttonLogout'
                                            className="nav-link"
                                            style={{ cursor: 'pointer' }}
                                            onClick={logoutARPA}>
                                            Logout
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </>
                    ) : <div className="collapse navbar-collapse" id="navbarSupportedContent">&nbsp;</div>}

                </nav>

                {!location.pathname.includes('/superAdmin/databaseEditor') && <Images />}

                {auth.ruoloScelto && <Breadcrumbs pathBreadcrumb={pathBreadcrumb} />}
            </div>

            <Notifs />
        </header>
    )
}


export default Header;
